"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatePayload;
function generatePayload(searchType, searchState) {
  if (searchType === 'agent') {
    return {
      searchby: searchState.searchByName === false ? 'coordinates' : 'name',
      latitude: searchState.searchByName === false ? searchState.lat : 0,
      longitude: searchState.searchByName === false ? searchState.lng : 0,
      dist: searchState.distanceMiles,
      searchterm: searchState.searchByName === true ? searchState.nameOrZipCodeInputSelection : '',
      specialty: searchState.specialtySelection ? searchState.specialtySelection.map(selection => selection.label).join(',') : '',
      languages: searchState.languageSelection ? searchState.languageSelection.map(selection => selection.label).join(',') : '',
      upperlat: searchState.upperlat ? searchState.upperlat : 0,
      upperlon: searchState.upperlng ? searchState.upperlng : 0,
      nextavailabledistsearch: !searchState.disableNextAvailableDistSearch
    };
  } else if (searchType === 'agency') {
    return {
      searchby: searchState.searchByName === false ? 'coordinates' : 'name',
      latitude: searchState.searchByName === false ? searchState.lat : 0,
      longitude: searchState.searchByName === false ? searchState.lng : 0,
      dist: searchState.distanceMiles,
      nextavailabledistsearch: false,
      searchterm: searchState.searchByName === true ? searchState.nameOrZipCodeInputSelection : '',
      specialty: searchState.specialtySelection ? searchState.specialtySelection.map(selection => selection.label).join(',') : '',
      languages: searchState.languageSelection ? searchState.languageSelection.map(selection => selection.label).join(',') : '',
      upperlat: searchState.upperlat ? searchState.upperlat : 0,
      upperlon: searchState.upperlng ? searchState.upperlng : 0,
      checkshowoncareer: false,
      nextavailabledistsearch: !searchState.disableNextAvailableDistSearch
    };
  }
  return null;
}